import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { BudgetTimeframesType } from '@shared/types/budget.interface';
import { TimeframeConfigDialog } from '@manage-ceg/types/manage-ceg-page.types';
import { TimeframeConfigDialogComponent } from '@manage-ceg/dialogs/timeframe-config-dialog/timeframe-config-dialog.component';
import { BudgetTimeframe } from '@shared/types/timeframe.interface';
import { Subject, takeUntil } from 'rxjs';
import { BudgetDataService } from '../../../dashboard/budget-data/budget-data.service';

@Component({
  selector: 'timeframe-configuration',
  templateUrl: './timeframe-configuration.component.html',
  styleUrls: ['./timeframe-configuration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimeframeConfigurationComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private budgetDataService = inject(BudgetDataService);

  @Input() selectedTimeframeMode: BudgetTimeframesType;
  @Input() budgetEndDate: string;
  @Input() budgetTimeframes: BudgetTimeframe[];
  @Input() selectedTimeframes: (number | string)[];
  @Input() disabled: boolean = false;

  @Output() onTimeframeConfigChange = new EventEmitter<(number | string)[]>();

  @ViewChild('configBtn', { read: ElementRef, static: true }) configBtn: ElementRef;

  readonly budgetTimeframesType = BudgetTimeframesType;
  private readonly dialog = inject(MatDialog);

  private budgetId: string;
  private companyId: string;

  ngOnInit(): void {
    this.budgetDataService.selectedBudget$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(data => {
      this.companyId = data.company.toString();
      this.budgetId = data.id.toString();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
  }

  showConfigDialog(): void {
    const dialogData: TimeframeConfigDialog = {
      timeframeMode: this.selectedTimeframeMode,
      fiscalYearLabel: `FY'${new Date(this.budgetEndDate).getUTCFullYear().toString().substring(2)}`,
      budgetTimeframes: this.budgetTimeframes,
      selectedTimeframes: this.selectedTimeframes,
      companyId: this.companyId,
      budgetId: this.budgetId,
      onSubmit: selectedTimeframes => this.onTimeframeConfigChange.emit(selectedTimeframes)
    };
    const { bottom, left, width } = this.configBtn.nativeElement.getBoundingClientRect();
    const isMonthMode = this.selectedTimeframeMode === BudgetTimeframesType.Month;
    const dialogWidth = isMonthMode ? 326 : 368;
    const offset = (left + (width / 2)) - dialogWidth / 2 - (isMonthMode ? 5 : 25);

    this.dialog.open(TimeframeConfigDialogComponent, {
      backdropClass: 'cdk-overlay-transparent-backdrop',
      panelClass: 'ceg-timeframe-config-dialog',
      scrollStrategy: new NoopScrollStrategy(),
      autoFocus: false,
      data: dialogData,
      width: `${dialogWidth}px`,
      position: {
        top: `${bottom}px`,
        left: `${offset}px`
      }
    });
  }
}
